import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import { getOptionalConcessionColumns } from '../utils/OptionalConcessionMasterColumns';
import { OptionalConcessionMaster } from '../types';
import ConfirmationDialog from '../../../components/ConfirmationDialog/ConfirmationDialog';
import { isEmpty } from 'lodash';
import { SnackbarSeverityType } from '../../../enums';
import OptionalConcessionMasterModal from './OptionalConcessionMasterModal';
import optionalConcession from '../../../apis/optionalConcession';

const OptionalConcessionMasterTable = ({
  OptionalConcessionMasterData,
  showToast,
  isLoading,
  fetchOptionalConcessionMaster
}: {
  OptionalConcessionMasterData: OptionalConcessionMaster[] | undefined;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
  isLoading: boolean;
  fetchOptionalConcessionMaster: () => Promise<void>;
}) => {
  const [
    isEditPaymentConcessionModalOpen,
    setIsEditPaymentConcessionModalOpen
  ] = useState(false);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const [selectedConcessionData, setSelectedConcessionData] =
    useState<OptionalConcessionMaster>();

  const handleOptionalConcessionEdit = (
    selectedRow: OptionalConcessionMaster
  ) => {
    setSelectedConcessionData(selectedRow);
    setIsEditPaymentConcessionModalOpen(true);
  };

  const handleDelete = (selectedRow: OptionalConcessionMaster) => {
    setSelectedConcessionData(selectedRow);
    setConfirmDialogOpen(true);
  };

  const handleDialogConfirm = async () => {
    if (isEmpty(selectedConcessionData?.id)) return;
    try {
      await optionalConcession.deleteSchoolOptionalConcessionMaster(
        selectedConcessionData?.id || ''
      );
      showToast(
        `Successfully deleted ${selectedConcessionData?.concessionName}`,
        SnackbarSeverityType.success
      );
    } catch (error: any) {
      showToast(
        error.errors?.[0].message ||
          `Error delete ${selectedConcessionData?.concessionName}`,
        SnackbarSeverityType.error
      );
    } finally {
      setConfirmDialogOpen(false);
      fetchOptionalConcessionMaster();
    }
  };

  const handleDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const columns = getOptionalConcessionColumns(
    handleOptionalConcessionEdit,
    handleDelete
  );

  const handleEditConcessionModalChange = () => {
    setIsEditPaymentConcessionModalOpen((prev) => !prev);
  };
  return (
    <>
      <DataGrid
        rowHeight={50}
        rows={OptionalConcessionMasterData}
        columns={columns}
        disableRowSelectionOnClick
        loading={isLoading}
        pageSizeOptions={[10, 20, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />

      <OptionalConcessionMasterModal
        isOptionalConcessionModalOpen={isEditPaymentConcessionModalOpen}
        heading={'Edit Concession'}
        buttonTitle={'Update'}
        mode='edit'
        fetchOptionalConcessionMaster={fetchOptionalConcessionMaster}
        selectedConcessionData={selectedConcessionData}
        onClose={handleEditConcessionModalChange}
        showToast={showToast}
      />
      <ConfirmationDialog
        message={'Are you sure you want to delete'}
        open={confirmDialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogConfirm}
      />
    </>
  );
};

export default OptionalConcessionMasterTable;
